import { Sanitize } from '@components/Sanitize';
import { IOption } from '@customTypes/common';

interface IProps {
  title: string;
  data: IOption[][];
}

const PatientInfoCard = ({ title, data }: IProps) => {
  return (
    <div className='py-3 px-3 px-md-4 bg-white rounded-4 d-flex flex-column patient-information-card'>
      <p className='fw-bold'>{title}</p>
      {data.map((row, rowIndex) => (
        <div className='d-flex flex-column flex-md-row gap-4 ps-0 ps-md-3 info-row' key={`row-${rowIndex}`}>
          {row.map((item, itemIndex) => (
            <div className='d-flex flex-column info-cell' key={`item-${itemIndex}`}>
              <p className='text-secondary fw-semibold fs-sm info-label'>{item.label}</p>
              <Sanitize as='p' className='mb-1 info-value'>
                {item.value}
              </Sanitize>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default PatientInfoCard;
